module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAABHNCSVQICAgIfAhkiAAAAQxJREFUOE+tk2FxwkAUhHcVlDqgCqAKShUQB6UOigKKgoICkEAVtBIiIRJwsMxmXmZCerlCJvfzbm/vu/f2ET1L0grAF8nHPk13nymhpA8b+YxkUpO690co6QjgrREPMpM0AXAAULRfvdssjH4AzDP1KQH8AtiTrJLflGQDE+WMundPAN5Jnq9+IckbD7d2rKUz3XPbkBEBkw1Z/vprY1h3U5KL7i4OIdyS/Kxj1OBE7VzgruG2g7wA8NLac5meTHeVszA04SyXs+i+g70J3ZrkLhVa582EtWEuZ5JM6Uh9kyz6xsmGJlz+F9oYvY1nODt3fpmkKbNLUkVyevMQ59yCrhzLbApgHLLI6uQCyY1hmV3j12gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/UndoIcon.png
// module id = qMKF
// module chunks = 3